/**
 * 数据看板 - 接口定义
 */
import { apiGet } from '@/utils/request';
import type {
  AllocationStatsItem,
  DashboardStatsParams,
  DashboardStatsResponse,
  GuideStatsResponse,
  LeadStatsItem,
  ServingStatsItem,
} from '@/types/dashboardReception';

export const dashboardApi = {
  config: (params?: Record<string, unknown>) => apiGet('/dashboard/config', params),
  all: (params?: Record<string, unknown>) => apiGet('/dashboard/all', params),
  summary: (params?: Record<string, unknown>) => apiGet('/dashboard/summary', params),
  trend: (params?: Record<string, unknown>) => apiGet('/dashboard/trend', params),
  privateMessages: (params?: Record<string, unknown>) =>
    apiGet('/dashboard/private-messages', params),
  /** 留资数据看板：账号 / 渠道 / 机器人维度 */
  leadStats: (params: DashboardStatsParams) =>
    apiGet<DashboardStatsResponse<LeadStatsItem>>('/dashboard/lead-stats', params),
  /** 接待数据看板：坐席 / 坐席分组 / 日期维度 */
  servingStats: (params: DashboardStatsParams) =>
    apiGet<DashboardStatsResponse<ServingStatsItem>>('/dashboard/serving-stats', params),
  /** 分配数据看板：坐席 / 坐席分组 / 日期维度 */
  allocationStats: (params: DashboardStatsParams) =>
    apiGet<DashboardStatsResponse<AllocationStatsItem>>('/dashboard/allocation-stats', params),
  /** 导购数据看板：仅统计抖音渠道，支持日期、渠道账号与机器人维度。 */
  guideStats: (params: DashboardStatsParams) =>
    apiGet<GuideStatsResponse>('/guide-stat/statistics', params),
};
